<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  interface Emits {
    (e: 'back'): void
  }

  const emit = defineEmits<Emits>()

  const FlowQuoteWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowQuoteWidget/FlowQuoteWidget.vue')
  )
  const FlowQuoteWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowQuoteWidgetQC/FlowQuoteWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isDsQuoteEnabled = computed(() => featuresStore.isDsQuoteEnabled)
</script>

<template>
  <FlowQuoteWidgetQC v-if="isDsQuoteEnabled" @back="emit('back')" />
  <FlowQuoteWidget v-else @edit-travelers="emit('back')" />
</template>
